import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { lazy, Suspense, useMemo } from 'react';
import { Box, Spinner, Typography } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import { GetAnalystAgentPaneTID } from '../AnalystAgentPane.utils';
import styles from './AnalystChartMessage.module.scss';
import { isRenderableChartSpec, title } from './AnalystChartMessage.utils';
const AnalystChartMessageInner = /*#__PURE__*/ lazy(()=>import(/* webpackChunkName: "recharts" */ './AnalystChartMessageInner').then((module)=>({
            default: module.AnalystChartMessageInner
        })));
export const AnalystChartMessage = (param)=>{
    let { messageId, part } = param;
    const { t } = useLocaleKeys('analystAgent');
    const { AnalystAgentPaneTestIds } = useMemo(()=>GetAnalystAgentPaneTID(messageId), [
        messageId
    ]);
    const { spec } = part;
    if (!isRenderableChartSpec(spec)) return null;
    const chartTitle = title(spec);
    const accessibleName = chartTitle !== null && chartTitle !== void 0 ? chartTitle : t.chart.chartLabel();
    const description = t.chart.chartDescription({
        chartType: t.chart.chartTypeNames[spec.chart_type]()
    });
    const descriptionId = "analyst-chart-description-".concat(messageId);
    return /*#__PURE__*/ _jsxs(Box, {
        className: styles.root,
        role: "figure",
        "aria-label": accessibleName,
        "aria-describedby": descriptionId,
        testId: AnalystAgentPaneTestIds.ChartMessage(),
        children: [
            chartTitle != null && /*#__PURE__*/ _jsx(Typography, {
                className: styles.title,
                weight: "bold",
                variant: "paragraph3",
                testId: AnalystAgentPaneTestIds.ChartTitle(),
                children: chartTitle
            }),
            /*#__PURE__*/ _jsx(Box, {
                as: "span",
                id: descriptionId,
                className: styles.description,
                testId: AnalystAgentPaneTestIds.ChartDescription(),
                children: description
            }),
            /*#__PURE__*/ _jsx(Suspense, {
                fallback: /*#__PURE__*/ _jsx(Box, {
                    className: styles.fallback,
                    children: /*#__PURE__*/ _jsx(Spinner, {
                        size: 24
                    })
                }),
                children: /*#__PURE__*/ _jsx(AnalystChartMessageInner, {
                    messageId: messageId,
                    spec: spec
                })
            })
        ]
    });
};
